import React from 'react'
import './Mark.css'

const Mark = () => (<div className="mark" />)

export default Mark;



// WEBPACK FOOTER //
// ./src/widgets/NetflixSlider/Mark.js